import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const BurgerIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 38 32"
      height={getDefaultHeight(svgProps, 32)}
      {...svgProps}
      fill={color}
    >
      <path d="M0 0h38.174v4.233h-38.174v-4.233z"></path>
      <path d="M0 13.884h38.174v4.233h-38.174v-4.233z"></path>
      <path d="M0 27.767h38.174v4.233h-38.174v-4.233z"></path>
    </SVG>
  );
};
